import { Font } from 'themes/interfaces';

export default {
  xxxs: 10,
  xxs: 11,
  xs: 12,
  sm: 14,
  md: 18,
  lg: 24,
  xl: 32,
  xxl: 44,
  xxxl: 56,
  thin: '300',
  extraLight: '300',
  light: '300',
  normal: '400',
  medium: '500',
  semiBold: '600',
  bold: '700',
  extraBold: '800',
  black: '900',
} as Font;
